<div class="modal fade" id="kt_modal_shipping_line_add_edit" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered mw-650px">
    <div class="modal-content">
      <div class="modal-header p-3 d-flex justify-content-between bg-secondary">
        <h2 class="fw-bold m-0">{{ isEditMode ? 'Update Shipping Line' : 'Add Shipping Line' }}</h2>
        <div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal">
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
      </div>

      <form [formGroup]="shippingLineForm" (ngSubmit)="onSubmit()" novalidate>
        <div class="modal-body p-5">
          <div class="row">
            <!-- Shipping Line Name -->
            <div class="col-md-12 mb-5">
              <label class="form-label required">Name</label>
              <input
                type="text"
                class="form-control form-control-solid"
                formControlName="name"
                placeholder="Enter shipping line name"
                [class.is-invalid]="name?.invalid && name?.touched"
              />
              <div *ngIf="name?.invalid && name?.touched" class="invalid-feedback">
                <div *ngIf="name?.errors?.['required']">Shipping line name is required</div>
                <div *ngIf="name?.errors?.['minlength']">Shipping line name must be at least 2 characters</div>
              </div>
            </div>

            <!-- Booking Agent -->
            <div class="col-md-12 mb-5">
              <label class="form-label">Booking Agent</label>
              <input
                type="text"
                class="form-control form-control-solid"
                formControlName="booking_agent"
                placeholder="Enter booking agent name"
                [class.is-invalid]="booking_agent?.invalid && booking_agent?.touched"
              />
              
            </div>

            <!-- Type -->
            <div class="col-md-12 mb-5">
              <label class="form-label required">Type</label>
              <div class="d-flex gap-5 mt-3">
                <div class="form-check form-check-custom form-check-solid">
                  <input
                    class="form-check-input"
                    type="radio"
                    value="roro"
                    formControlName="type"
                    id="type_roro"
                  />
                  <label class="form-check-label" for="type_roro">
                    RORO
                  </label>
                </div>
                <div class="form-check form-check-custom form-check-solid">
                  <input
                    class="form-check-input"
                    type="radio"
                    value="ctn"
                    formControlName="type"
                    id="type_ctn"
                  />
                  <label class="form-check-label" for="type_ctn">
                    CTN
                  </label>
                </div>
              </div>
              <div *ngIf="type?.invalid && type?.touched" class="invalid-feedback d-block">
                <div *ngIf="type?.errors?.['required']">Type is required</div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-light me-3"
            data-bs-dismiss="modal"
            [disabled]="isLoading">
            Cancel
          </button>
          <button
            type="submit"
            class="btn btn-primary"
            [disabled]="isLoading">
            <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2"></span>
            {{ isEditMode ? 'Update' : 'Add' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
